import 'moment/locale/cs'
import Globalize from 'globalize'
import globalizeLocalizer from 'react-widgets-globalize'

# Globalize.locale('cs')

globalizeLocalizer()
